import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { updateIntercom } from 'intercom';

const PageTitle = (): null => {
  const location = useLocation();

  useEffect(() => {
    let intervalCount = 0,
      oldTitle: string,
      newTitle: string;

    const setTitle = () => {
      intervalCount++;
      const h1Text = document.querySelector('h1')?.textContent;
      const h2Text = document.querySelector('h2')?.textContent;
      const h3Text = document.querySelector('h3')?.textContent;

      const text = h1Text ?? h2Text ?? h3Text;
      const hasText = (text ?? '').trim().replace(/[^a-zA-Z]/gim, '');

      oldTitle = document.title;
      newTitle = hasText ? `${text} | My Eduzz` : 'My Eduzz';
      document.title = newTitle;

      if (hasText) {
        updateIntercom();
      }

      if ((hasText || intervalCount > 10) && interval) {
        clearInterval(interval);
      }
    };

    const interval = setInterval(setTitle, 500);
    setTitle();

    return () => {
      clearInterval(interval);

      if (document.title !== newTitle) return;
      document.title = oldTitle;
    };
  }, [location.pathname, location.search]);

  return null;
};

export default PageTitle;
